import { Switch } from "@bidbattles/bloks/components/ui/switch";
import {
	BBBackendClient,
	BBBackendQueryOptions,
	type NotificationPreferences,
} from "@bidbattles/bloks/lib/rapace";
import { webPush } from "@/lib/push";
import { cn } from "@bidbattles/bloks/lib/ui";
import { m } from "@/paraglide/messages";
import {
	useMutation,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";

export const Route = createFileRoute("/settings/notifications_/preferences")({
	async loader({ context }) {
		const queries = [BBBackendQueryOptions.fetchNotificationPreferences()];
		await Promise.all(
			queries.map((query) => context.queryClient.ensureQueryData(query)),
		);
	},
	component: RouteComponent,
	ssr: "data-only",
});

function RouteComponent() {
	const queryClient = useQueryClient();
	const pns = webPush.usePermission();
	const { data: notificationPreferences } = useSuspenseQuery(
		BBBackendQueryOptions.fetchNotificationPreferences(),
	);

	const updateNotificationPreferencesMutation = useMutation({
		mutationFn: async (value: NotificationPreferences) => {
			const result = await BBBackendClient.updateNotificationPreferences(value);
			if (!result.ok) {
				toast.error(m.error_toast({ message: result.error.message }));
				return;
			}

			await queryClient.invalidateQueries(
				BBBackendQueryOptions.fetchNotificationPreferences(),
			);
			toast.success(
				value.email
					? "Email notifications enabled"
					: "Email notifications disabled",
			);
		},
	});

	let pnsEnabled = !!pns.subscription;
	if (pns.enabling) {
		pnsEnabled = true;
	} else if (pns.disabling) {
		pnsEnabled = false;
	}

	return (
		<form className="flex flex-col gap-5" onSubmit={(e) => e.preventDefault()}>
			<label
				className={cn(
					"flex items-center gap-4",
					updateNotificationPreferencesMutation.isPending && "opacity-75",
				)}
			>
				<Switch
					disabled={updateNotificationPreferencesMutation.isPending}
					checked={notificationPreferences.email}
					onCheckedChange={(email) => {
						updateNotificationPreferencesMutation.mutate({
							...notificationPreferences,
							email,
						});
					}}
				/>
				Receive email notifications
			</label>
			{pns.supported && (
				<label
					className={cn(
						"flex items-center gap-4",
						pns.toggling && "opacity-75",
					)}
				>
					<Switch
						disabled={pns.toggling}
						checked={pnsEnabled}
						onCheckedChange={(enabled) => {
							if (enabled) {
								pns.enable();
							} else {
								pns.disable();
							}
						}}
					/>
					<div className="flex flex-col gap-1">
						<span>Receive push notifications</span>
						<span className="text-gray-500 text-sm">Only on this device</span>
					</div>
				</label>
			)}
		</form>
	);

	// return (
	// 	<form
	// 		onSubmit={(e) => {
	// 			e.preventDefault();
	// 			form.handleSubmit(e);
	// 		}}
	// 		className="flex flex-col gap-5"
	// 	>
	// 		<form.AppField name="email">
	// 			{(field) => (
	// 				<label className="flex items-center gap-2">
	// 					<field.Switch /> Enable e-mail notifications
	// 				</label>
	// 			)}
	// 		</form.AppField>

	// 		<div className="ms-auto mt-4 inline-flex gap-4">
	// 			<form.AppForm>
	// 				<form.ResetButton label="Cancel" />
	// 				<form.SubscribeButton label="Save" />
	// 			</form.AppForm>
	// 		</div>
	// 	</form>
	// );
}
